module.exports = __webpack_public_path__ + "static/media/car-dealer.16953fa7.JPG";